import { useState } from 'react';
import { ClarionButton, ClarionButtonProps } from '../clarion/ClarionButton';
import { AppToaster } from './toaster';

export type ActionButtonProps = ClarionButtonProps & {
  action: () => Promise<void>;
  confirm?: () => Promise<boolean>;
  text?: string;
};

// Button that takes an async onClick and provides a loading state and default error toast.
// The optional confirm function will be awaited before the loading state is set.
export default function ActionButton({ action, confirm, ...props }: ActionButtonProps) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    if (confirm && !(await confirm())) return;
    setLoading(true);
    try {
      await action();
    } catch (error) {
      console.error(error);
      // The provided action can have its own catch block to prevent this default error message from showing
      AppToaster.clear();
      const actionLabel = props.text || props.tooltip || props['aria-label'] || 'Action';
      const message = `${(error instanceof Error && error.message) || `${actionLabel} failed.`} Please try again, or contact us if the problem continues.`;
      AppToaster.show({ intent: 'danger', message: message });
    }
    setLoading(false);
  };

  return <ClarionButton loading={loading} onClick={handleClick} {...props} />;
}
